import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroPlanoTrabalho from './components/CadastroPlanoTrabalho';

//Contants
import { actionsTable } from '../../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../../context/auth';

//API
import planoTrabalho_api from '../../../../api/planoTrabalho_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

function PlanoTrabalho({ permissoes }) {
    //State para Editar o perfil dos usuario
    const [planoTrabalho_id, setPlanoTrabalho_id] = useState(null);

    //State para pegar os perfil dos usuario
    const [planoTrabalhoNovo, setPlanoTrabalhoNovo] = useState(false);

    //State para pegar os perfil dos usuario
    const [listPlanoTrabalho, setListPlanoTrabalho] = useState([]);

    const { setLoading } = useAuth();

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Contratada", objectValue: "contratada", align: "left" },
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ];

    const editarPlanoTrabalho = (rowData) => {
        setPlanoTrabalho_id(rowData.id);
    }

    const visualizarPlanoTrabalho = (rowData) => {
        setPlanoTrabalho_id(rowData.id);
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editarPlanoTrabalho)]
            : [actionsTable.visualizar(visualizarPlanoTrabalho)]
    ];

    const loadPlanoTrabalho = () => {
        setLoading(true);
        planoTrabalho_api
            .getList().then(response => setListPlanoTrabalho(response.data))
            .catch(error => showMessage("Error", error?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadPlanoTrabalho();
    }, []);

    const handleVoltar = () => {
        setPlanoTrabalhoNovo(false);
        setPlanoTrabalho_id(null);
        loadPlanoTrabalho();
    }

    if(planoTrabalhoNovo || planoTrabalho_id){
        return <CadastroPlanoTrabalho
            id={planoTrabalho_id}
            handleVoltar={handleVoltar}
            editavel={editavel}
        />
    }

    return <>
        <div className={`d-flex align-items-center justify-content-between mb-4 ${editavel ? "" : "d-none"}`}>
            <h4 className='text-secondary m-0'>Plano trabalho</h4>
            {editavel && <Button color='success' onClick={() => { setPlanoTrabalhoNovo(true) }}>+ Cadastrar</Button>}
        </div >
        <TabelaListagem
            actions={actions}
            title={"Lista de plano trabalho"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listPlanoTrabalho}
        />
    </>;
}

export default PlanoTrabalho;